/**
 * Gate for the internal tool pages (underlag / SJA / kontroll) that used to be
 * fully public. Now they are private:
 *  - No session at all            → redirect to the Doserne login.
 *  - Doserne member, courses done → allowed.
 *  - Doserne member, courses left → redirect to the courses page (internal rules).
 *  - Main-platform (AllStillas) admin session → allowed (never blocked here).
 * Token-based sign/edit links are NOT wrapped by this guard, so external
 * signing keeps working.
 */
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DOSERNE_TOKEN = "DOSERNE_TOKEN";
const MAIN_TOKEN = "scaffoldx_token";

export default function DoserneAccessGuard({ children }) {
  const [state, setState] = useState("checking"); // checking | login | kurs | allowed

  useEffect(() => {
    const dToken = localStorage.getItem(DOSERNE_TOKEN);
    const mToken = localStorage.getItem(MAIN_TOKEN);
    if (!dToken) {
      // Main-platform admins keep access; anonymous public gets sent to login.
      setState(mToken ? "allowed" : "login");
      return undefined;
    }
    let cancelled = false;
    axios
      .get(`${API}/doserne/kurs/gate-status`, { headers: { Authorization: `Bearer ${dToken}` } })
      .then((r) => { if (!cancelled) setState(r.data?.blocked ? "kurs" : "allowed"); })
      .catch(() => {
        if (cancelled) return;
        if (mToken) { setState("allowed"); return; }
        try { localStorage.removeItem(DOSERNE_TOKEN); } catch (_e) { /* ignore */ }
        setState("login");
      });
    return () => { cancelled = true; };
  }, []);

  if (state === "login") return <Navigate to="/doserne/logg-inn" replace />;
  if (state === "kurs") return <Navigate to="/doserne/kurs" replace />;
  if (state === "allowed") return children;
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="doserne-access-guard-loading">
      <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
    </div>
  );
}
